import React, { useState, useEffect } from "react";
import { Link, Redirect, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
// @material-ui/core components
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  LinearProgress,
  CircularProgress,
} from "@material-ui/core";
// @material-ui/styles
import styles from "../../../../../assets/jss/layouts/appStyle";
import { makeStyles } from "@material-ui/core/styles";
// core components
import { EducationalTypeRepository } from "./EducationalTypeRepository";
import { LOCALE } from "../../../../../properties/Locale";
import {
  notifyShowSuccessMessage,
  notifyShowErrorMessage,
  triggerRerender,
} from "../../../../../common/actions/CommonActions";
import Card from "../../../../../common/components/Card/Card.js";
import CardHeader from "../../../../../common/components/Card/CardHeader.js";
import CardBody from "../../../../../common/components/Card/CardBody.js";

const useStyles = makeStyles(styles);

export default function EducationalTypeDeleteComponent(props) {
  const classes = useStyles();
  const [educationalTypeId] = useState(props.match.params.educationalTypeId);
  const [loading, setLoading] = useState(false);
  const [redirectTo, setRedirectTo] = useState();
  const [btnSubmitLoading, setBtnSubmitLoading] = useState(false);
  const [data, setData] = useState();
  const dispatch = useDispatch();
  let { gradingSchemaId } = useParams();

  useEffect(() => {
    const loadEducationalType = (id) => {
      showLoadingBar();
      EducationalTypeRepository.fetch(id).then((res) => {
        setData(res.data);
        hideLoadingBar();
      });
    };
    loadEducationalType(educationalTypeId);
  }, [educationalTypeId]);

  const showLoadingBar = () => {
    setLoading(true);
    setBtnSubmitLoading(true);
  };

  const hideLoadingBar = () => {
    setLoading(false);
    setBtnSubmitLoading(false);
  };

  const handleSubmit = () => {
    showLoadingBar();
    EducationalTypeRepository.delete(data.id)
      .then((res) => {
        hideLoadingBar();
        dispatch(triggerRerender());
        dispatch(
          notifyShowSuccessMessage(
            LOCALE.educational_activity_type_deleted_success_message
          )
        );
        setRedirectTo(
          `/app/configuration/gradingSchema/${gradingSchemaId}/edit`
        );
      })
      .catch((err) => {
        hideLoadingBar();
        dispatch(notifyShowErrorMessage(err.message));
      });
  };

  const handleClose = () => {};

  return (
    <div>
      {redirectTo && <Redirect to={redirectTo} />}
      <Card>
        <Dialog
          open={true}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
          PaperProps={{
            style: {
              overflowY: "unset",
            },
          }}
        >
          <CardHeader color="theme">
            <h4 className={classes.cardTitleWhite}>{`${
              LOCALE.educational_activity_type_delete
            }${data?.name ? ": " + data?.name : ""}`}</h4>
          </CardHeader>
          <CardBody>
            {loading ? <LinearProgress color="secondary" /> : ""}
            <div>
              <DialogContent>
                {LOCALE.entity_delete_confirmation_text}?
              </DialogContent>
              <DialogActions>
                {!btnSubmitLoading && (
                  <Link
                    to={`/app/configuration/gradingSchema/${gradingSchemaId}/edit`}
                    style={{ textDecoration: "none" }}
                  >
                    <Button size="small" variant="outlined" color="secondary">
                      {LOCALE.cancel}
                    </Button>
                  </Link>
                )}
                <Button
                  onClick={handleSubmit}
                  size="small"
                  variant="contained"
                  disabled={btnSubmitLoading}
                  className={btnSubmitLoading ? "btn-loading" : ""}
                  color="secondary"
                >
                  {LOCALE.delete}
                  {btnSubmitLoading && (
                    <CircularProgress
                      color="secondary"
                      size={20}
                      style={{ position: "absolute" }}
                    />
                  )}
                </Button>
              </DialogActions>
            </div>
          </CardBody>
        </Dialog>
      </Card>
    </div>
  );
}
